import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Accueil', path: '/' },
    { name: 'Mâle Reproducteur', path: '/reproducteur' },
    { name: 'Conditions', path: '/conditions' },
    { name: 'Tarifs', path: '/tarifs' },
    { name: 'Galerie', path: '/galerie' },
    { name: 'Disponibilités', path: '/disponibilites' },
    { name: 'Témoignages', path: '/temoignages' },
    { name: 'Infos Utiles', path: '/infos' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-black/95 backdrop-blur-sm border-b border-[#cbb26a]/20">
      {/* plus d’espace à gauche/droite */}
      <div className="mx-auto px-4 md:px-10">
        <div className="flex items-center gap-8 py-4 md:py-5">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="/images/logo.png"
              alt="LabradorLOF – Génétique d'excellence"
              className="h-14 md:h-36 lg:h-40 w-auto object-contain"
            />
          </Link>

          {/* Navigation desktop, étalée sur toute la barre */}
          <nav className="hidden lg:flex flex-1 justify-center">
            <div className="flex items-center gap-8 xl:gap-10">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-2 py-2 text-xs md:text-sm xl:text-base tracking-[0.18em] uppercase font-medium transition-all duration-300 rounded-md ${
                    isActive(item.path)
                      ? 'text-[#cbb26a] bg-[#cbb26a]/10'
                      : 'text-white/80 hover:text-[#cbb26a] hover:bg-white/5'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </nav>

          {/* Bouton téléphone (desktop) */}
          <div className="hidden lg:flex items-center space-x-3 shrink-0">
            <Button
              asChild
              className="bg-[#cbb26a] text-black hover:bg-[#d4c485] transition-all duration-300"
            >
              <a href="tel:0756963191" className="flex items-center space-x-2">
                <Phone size={16} />
                <span>0756963191</span>
              </a>
            </Button>
          </div>

          {/* Bouton menu mobile */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-white p-2 hover:text-[#cbb26a] transition-colors duration-300 ml-auto"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Menu mobile */}
        {isMenuOpen && (
          <nav className="lg:hidden pb-4 border-t border-[#cbb26a]/20">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block px-4 py-3 text-sm font-medium uppercase tracking-[0.16em] transition-all duration-300 ${
                  isActive(item.path)
                    ? 'text-[#cbb26a] bg-[#cbb26a]/10'
                    : 'text-white/80 hover:text-[#cbb26a] hover:bg-white/5'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <div className="px-4 pt-4 space-y-2">
              <Button
                asChild
                className="w-full bg-[#cbb26a] text-black hover:bg-[#d4c485]"
              >
                <a
                  href="tel:0695134999"
                  className="flex items-center justify-center space-x-2"
                >
                  <Phone size={16} />
                  <span>0695134999</span>
                </a>
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
